import { axiosClient } from '../../services/axiosInstance'
import { getCookie } from '../cookies'

type CookieData = {
  name: string
  value: string
  maxAge: string
}

type DYCookies = {
  dyid: string
  dyidServer: string
  sessionId: string
}

let pendingPromise: Promise<DYCookies> | null = null

function updateFetchedCookies(
  cookies: CookieData[],
  dyid: string | null,
  sessionId: string | null
): DYCookies {
  const result: DYCookies = {
    dyid: dyid ?? '',
    dyidServer: dyid ?? '',
    sessionId: sessionId ?? '',
  }

  cookies?.flat().forEach(({ value, name }) => {
    if (name === '_dyid_server' && !dyid) {
      result.dyid = value
      result.dyidServer = value
    }

    if (name === '_dyjsession' && !sessionId) {
      result.sessionId = value
    }
  })

  return result
}

export async function ensureDYCookies(): Promise<DYCookies> {
  if (pendingPromise) {
    return pendingPromise
  }

  pendingPromise = (async () => {
    const dyid = getCookie('_dyid')
    const sessionId = getCookie('_dyjsession')

    if (dyid && sessionId) {
      pendingPromise = null

      return { dyid, dyidServer: dyid, sessionId }
    }

    try {
      const { data: cookies } = await axiosClient.get<CookieData[]>(
        '/api/getDynamicYieldCookies'
      )

      const fetchedCookies = updateFetchedCookies(
        cookies,
        dyid === undefined ? null : dyid,
        sessionId === undefined ? null : sessionId
      )

      pendingPromise = null

      return fetchedCookies
    } catch (error) {
      console.error(error)

      pendingPromise = null

      return {
        dyid: '',
        dyidServer: '',
        sessionId: '',
      }
    }
  })()

  return pendingPromise
}
